import { gql } from '@apollo/client';

const simplifiedOrderFragment = gql`
  fragment SimplifiedOrderFragment on ActiveOrder {
    id
    easyId
    createdAt
    status
    isTableOrder
    basketToken
    hasPrintedReceiptCopy
    paymentAmount
    paymentTip
    origin
  }
`;

export const SEARCH_ORDERS_QUERY = gql`
  query SearchOrders(
    $venueIds: [String!]!
    $companyId: String!
    $startDate: String
    $endDate: String
    $sum: Int
    $easyId: String
    $deviceId: String
    $first: Int
    $skip: Int
  ) {
    searchOrders(
      venueIds: $venueIds
      companyId: $companyId
      startDate: $startDate
      endDate: $endDate
      sum: $sum
      easyId: $easyId
      deviceId: $deviceId
      first: $first
      skip: $skip
    ) {
      results {
        ...SimplifiedOrderFragment
      }
    }
  }

  ${simplifiedOrderFragment}
`;

const userFragment = gql`
  fragment UserFragment on User {
    id
    role
    venues {
      id
    }
    name
    email
    phone
    company {
      id
      hasMembershipCards
    }
    membershipLevel {
      id
      title {
        id
        en
        se
        no
        es
      }
    }
    membershipCard {
      membershipLevel {
        id
        title {
          id
          en
          se
          no
          es
        }
      }
    }
  }
`;

const orderfragment = gql`
  fragment Orderfragment on Order {
    id
    easyId
    createdAt
    status
    origin
    basketToken
    hasPrintedReceiptCopy
    complianceId
    posDevice {
      id
      name
    }
    payment {
      id
      amount
      tip
      correctedTip
      type
      createdAt
      transactionId
      status
      metadata {
        cardDetails {
          cardType
          cardPaymentEntryMode
          tsi
          tvr
          aid
          maskedPan
        }
      }
      subPayments {
        id
        createdAt
        updatedAt
        amount
        status
        type
        transactionId
        correctedTip
        tip
      }
    }
    items {
      id
      isRefunded
      fraction
      message
      entry {
        id
        item {
          id
          vatRate
          categories {
            id
            name
          }
          titleLang {
            id
            se
            en
            es
            no
          }

          descriptionLang {
            id
            se
            en
            es
            no
          }
        }
      }
      price {
        id
        percentageVAT
        amount
        discount
      }
      variations {
        id
        name
        price
        nameLang {
          id
          se
          en
          es
          no
        }
      }
      removedVariations {
        id
        name
        nameLang {
          id
          se
          en
          es
          no
        }
      }
    }
    type
    statusHistory
    isTableOrder
  }
`;

export const GET_ORDER = gql`
  query GetOrder($id: ID!) {
    order: Order(id: $id) {
      ...Orderfragment
      user {
        ...UserFragment
      }
    }
  }

  ${orderfragment}
  ${userFragment}
`;

export const SET_ORDER_HAS_PRINTED = gql`
  mutation SetOrderHasPrinted($id: ID!, $hasPrintedReceiptCopy: Boolean) {
    updateOrder(id: $id, hasPrintedReceiptCopy: $hasPrintedReceiptCopy) {
      id
      hasPrintedReceiptCopy
    }
  }
`;

export const EMAIL_ORDER_RECEIPT = gql`
  mutation EmailOrderReceipt(
    $orderId: ID!
    $email: String
    $language: String
    $userMetadata: UserMetadataInput
  ) {
    sendOrderEmail(
      orderId: $orderId
      email: $email
      language: $language
      userMetadata: $userMetadata
    ) {
      error
      message
      success
    }
  }
`;
